import React from "react";

// Ranking numbers should read as strong, standalone numerals — "01", not
// "Rank: 1" (§11). The top three get a subtle medal treatment; everyone else
// stays neutral. Deliberately not giant gold cards.
const MEDALS = {
  1: "bg-gold/20 text-[#8A6100] ring-gold/40",
  2: "bg-silver/25 text-[#4B5563] ring-silver/50",
  3: "bg-bronze/20 text-[#8A4B1F] ring-bronze/40",
};

const RankBadge = ({ rank, size = "md" }) => {
  const dims =
    size === "sm" ? "h-7 w-7 text-xs" : size === "lg" ? "h-12 w-12 text-lg" : "h-9 w-9 text-sm";
  const medal = MEDALS[rank];

  if (!rank) return <span className="text-muted">—</span>;

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-bold tabular ${dims} ${
        medal ? `ring-2 ${medal}` : "bg-bg text-muted"
      }`}
    >
      {rank}
    </span>
  );
};

export default RankBadge;
